// extracted by mini-css-extract-plugin
export default {"crisis":"CrisisAllocationClientsList_crisis__DvsYk"};